<template>
  <a-form ref='form' class="s_flex">
    <a-form-item label="关键字" name='keyword' >
      <a-input v-model:value="keyword" :style="{width:'300px'}" placeholder="请输入关键词进行搜索" />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" class="m-l-10" @click="getList()">搜索</a-button>
    </a-form-item>
  </a-form>
     <a-table  :data-source="list" :pagination="pagination" rowKey="id" bordered :loading="loading" @change="handleTableChange">
         <a-table-column key="name" title="音频信息" data-index="name">
              <template #default="{ record }">
                 <div class="s_flex_ali">
                    <img :src="defaultImg" alt="" class="s_bor5" width="50" height="50">
                     <p class="m-l-10">{{record.name || '无'}}</p>
                 </div>
              </template>    
         </a-table-column>
         <a-table-column key="id" title="操作" data-index="id" align="right">
              <template #default="{ record }">
                 <a-button type="primary" @click="select(record)" ghost>选择</a-button>
              </template>    
         </a-table-column>
     </a-table>
</template>

<script>
import {onMounted, reactive,toRefs} from 'vue';
import {wxMaterialVoice} from "@/api/public_wx";

export default {
   setup(props,{emit}){
       const state = reactive({
           list:[],
           pagination:{ //分页
             total:0,
             current:1,
             pageSize:10,
           },
           keyword:'',
           loading:false,
           defaultImg:require('@/assets/images/audio.png')
       })
 

       const getList = async function(){
           state.loading = true;
           let res = await wxMaterialVoice({page:state.pagination.current,limit:state.pagination.pageSize,keyword:state.keyword}).then(res=>res.data);
           state.loading = false;
           console.log(res)
           state.list = res.data.data || [];
           state.pagination.total = res.data.total;
            state.pagination.current = res.data.current_page;
            // if(state.list.length==0) return
            // console.log(props.audioID,2)
            // for(let i=0;i<state.list.length;i++){
            //     state.list[i].checked = false;
            //     if(state.list[i].id==props.audioID){
            //          state.list[i].checked = true;
            //     }
            // }
       }

       const handleTableChange = function(e){
           state.pagination.current=e.current;
           getList()
       }

       const select = function(val){
        //    val.checked = true;
           emit('change',val)
       }

      
       onMounted(()=>{
           getList()
       })

       return{
           ...toRefs(state),
           handleTableChange,
            select,
            getList
       }
   }
}
</script>

<style lang="less" scoped>
/deep/.ant-table-align-right .ant-table-column-title{
    padding-right:30px ;
}
</style>
